<script lang="ts" setup>
import { NuxtLinkLocale } from "#components";

const emit = defineEmits(["click"]);
const props = defineProps({
  craftingRequirements: {
    type: Object as PropType<CraftIngredient[]>,
    required: true,
  },
  detailView: {
    type: Boolean,
    required: false,
    default: false,
  },
  isLink: {
    type: Boolean,
    required: false,
    default: false,
  },
  canEmit: {
    type: Boolean,
    required: false,
    default: false,
  },
  showRequirements: {
    type: [Boolean, null] as PropType<boolean | null>,
    required: false,
    default: null,
  },
});
const userStore = useUserStore();

const { getMerchantAttributes } = useLuxuryDesign();

const amountValue = (
  requiredQuantity: number,
  availableQuantity: number | null
) => {
  if (requiredQuantity == 0 || props.showRequirements === false) return `?`;
  if (!userStore.isLoggedIn) return `x${requiredQuantity}`;
  return `${availableQuantity}/${requiredQuantity}`;
};

const textColor = (
  requiredQuantity: number,
  availableQuantity: number | null
) => {
  if (props.showRequirements === false) return "text-secondary-200";
  if (requiredQuantity == 0) return "text-secondary-200";
  if (!userStore.isLoggedIn) return "text-secondary-200";

  const actualQuantity = availableQuantity ?? 0;
  if (actualQuantity === 0) return "text-secondary-200";
  return actualQuantity >= requiredQuantity
    ? "text-success-300"
    : "text-secondary-200";
};
</script>

<template>
  <div class="flex gap-2 items-end" :class="detailView ? 'flex-wrap' : ''">
    <template
      v-for="(ingredient, index) in craftingRequirements"
      :key="ingredient.itemId">
      <div>
        <component
          :is="isLink ? NuxtLinkLocale : 'div'"
          :to="`/market/${ingredient.characteristics.merchantId}/stack/${
            ingredient.id
          }?return=${useRoute().fullPath}`"
          v-bind="getMerchantAttributes(ingredient.characteristics.merchantId)"
          class="relative"
          :class="canEmit ? 'cursor-pointer' : ''"
          @click="canEmit ? emit('click', index) : null">
          <img
            :src="getPortraitItemImage(ingredient.characteristics.imageId)"
            alt=""
            :class="detailView ? 'w-20 h-20' : 'w-12 h-12'" />
          <div
            class="absolute bottom-0 right-0 w-full z-10 border-b-2 craft-list__rarity-indicator"
            :class="
              getRarityColor(ingredient.characteristics.rarity, 'border')
            " />
        </component>
        <p
          class="text-center bg-secondary-500 border border-primary-900 border-t-0 rounded-b-md pt-0.5 px-2 font-bold font-[Roboto] tracking-widest"
          :class="
            textColor(ingredient.requiredQuantity, ingredient.availableQuantity)
          ">
          {{
            amountValue(
              ingredient.requiredQuantity,
              ingredient.availableQuantity
            )
          }}
        </p>
      </div>
    </template>
  </div>
</template>
